// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"7f3cae39","126":"7a1f409d","197":"c89516de","337":"ad98db44","510":"a2cb2810","538":"1e7473e3","555":"6eb710ae","609":"1922ce3d","709":"cedf79f8","716":"cb1cc2da","783":"fc8988f9","934":"51683a03"}[chunkId] + ".chunk.js";
};